import { Injectable, inject } from '@angular/core';
import { LogService } from '@logs/services/log.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '@globalization/services/translation.service';

const SERVICE_NAME = 'TranslationManagerService';

@Injectable()
export class TranslationManagerService {
  private logService: LogService = inject(LogService);
  private translateService: TranslateService = inject(TranslateService);
  private translationService: TranslationService = inject(TranslationService);

  public init(): void {
    this.setDefaultLang();
    this.useCurrentLang();
  }

  public get(translateParam: string): Observable<string> {
    return this.translateService.get(translateParam);
  }

  public setCurrentLang(lang: string): void {
    this.logService.logInfo(`[${SERVICE_NAME}] Setting new lang: ${lang}`);
    this.translationService.setCurrentLang(lang);
    this.translateService.use(lang);
  }

  private setDefaultLang(): void {
    this.translationService.getDefaultLang()
      .subscribe({
        next: (lang: string) => {
          this.logService.logInfo(`[${SERVICE_NAME}] Setting fallback lang: ${lang}`);
          this.translateService.setDefaultLang(lang);
        },
        error: () => this.logService.logError('Unable to set fallback lang for translation service')
      });
  }

  private useCurrentLang(): void {
    this.translationService.getCurrentLang()
      .subscribe({
        next: (lang: string) => {
          this.logService.logInfo(`[${SERVICE_NAME}] Setting current lang: ${lang}`);
          lang = lang.replace(/[^a-zA-Z0-9 -]/g, '');
          this.translateService.use(lang);
          this.translationService.setCurrentLang(lang);
        },
        error: () => this.logService.logError('Unable to set current language')
      });
  }
}
